<template>
	<div>
		<div style="display: flex;align-items: center;justify-content: space-between;">
			<a-breadcrumb style="margin: 16px 0">
				<a-breadcrumb-item>主页</a-breadcrumb-item>
				<a-breadcrumb-item>{{selectFirstMenu}}</a-breadcrumb-item>
				<a-breadcrumb-item>{{selectSecondMenu}}</a-breadcrumb-item>
			</a-breadcrumb>
			<div>
				<a-button class="qinang-button-margin" icon="plus" @click="addShow('add')">新增</a-button>
				<a-button class="qinang-button-margin" icon="delete" @click="tableDel">删除</a-button>
				<a-button icon="sync" @click="apiBannerQueryList">刷新</a-button>
			</div>
		</div>
		
		<a-collapse expandIconPosition="right" activeKey="1">
			<a-collapse-panel key="1" header="轮播图查询">
				<div style="display: flex;justify-content: space-between;">
					<div style="width: 30%;display: flex;align-items: center;">
						<div style="width: 120px;">所属服务商：</div>
						<a-select v-model="query.facilitatorId" style="width: 100%;">
							<a-select-option v-for="(item,index) in facilitatorList" :value="item.facilitatorId" :key="index">{{item.facilitatorName}}</a-select-option>
						</a-select>
					</div>
					<div style="width: 30%;display: flex;align-items: center;">
						<div style="width: 120px;">轮播图名称：</div>
						<a-input v-model="query.bannerName" style="width: 100%;" placeholder="请输入名称关键字查询" />
					</div>
					<div style="width: 30%;display: flex;align-items: center;justify-content: flex-end;">
						<a-button type="primary" icon="search" @click="apiBannerQueryList">查询</a-button>
					</div>
				</div>
			</a-collapse-panel>
		</a-collapse>
		
		<div class="qinang-card">
			<a-table :row-selection="rowSelection" :columns="tableColumns" :data-source="tableData" row-key="bannerId" :loading="tableLoading" :pagination="false">
				<span slot="bannerName" slot-scope="bannerName">
					<a-button type="link" @click="addShow('edit', bannerName)" >{{bannerName.bannerName}}</a-button>
				</span>
				<span slot="facilitatorId" slot-scope="facilitatorId">
					{{mainNavigation[0].facilitatorName}}
				</span>
				<span slot="bannerImg" slot-scope="bannerImg">
					<input type="image" :src="navigation.url + bannerImg" alt="" style="height: 50px;object-fit: cover;" />
				</span>
				<span slot="bannerState" slot-scope="bannerState">
					<span v-if="bannerState == 2">禁用</span>
					<span v-if="bannerState == 3">启用</span>
				</span>
			</a-table>
			<a-pagination style="text-align: right;margin: 10px;" :current="query.page" :total="query.total" :default-page-size="query.size" show-size-changer show-quick-jumper size="small" :page-size-options="['10', '20', '50']"
				:show-total="total => `共 ${total} 条记录`" @change="pageChange" @showSizeChange="showSizeChange"/>
		</div>

		<!-- 添加弹窗 -->		
		<a-modal :title="bannerVisibleConfig.title" width="60%" :visible="addVisible" :confirm-loading="addConfirmLoading" @ok="addHandleOk" @cancel="addVisible = false" :maskClosable="false" :keyboard="false" >
			<a-form-model style="" ref="addRuleForm" :model="addForm" :label-col="{span: 4}" :wrapper-col="{span: 18}" :rules="addRules">
				<a-form-model-item label="服务商名称" has-feedback prop="facilitatorId">
					<a-select v-model="addForm.facilitatorId" >
						<a-select-option v-for="(item,index) in facilitatorList" :value="item.facilitatorId" :key="index">{{item.facilitatorName}}</a-select-option>
					</a-select>
				</a-form-model-item>
				<a-form-model-item label="轮播图名称" has-feedback prop="bannerName">
					<a-input v-model="addForm.bannerName" placeholder="请输入轮播图点名称" />
				</a-form-model-item>
				<a-form-model-item label="图片" has-feedback prop="bannerImg">
					<a-upload name="fileName" list-type="picture-card" :show-upload-list="false" :action="navigation.apiUploadFiles" @change="uploadHandleChange" :headers="uploadPublic.headers">
						<img style="height: 86px;height: 86px;object-fit: contain;" v-if="addForm.bannerImg" :src="navigation.url + addForm.bannerImg" alt="avatar" />
						<div v-else>
							<a-icon :type="uploadPublic.loading ? 'loading' : 'plus'" />
							<div>上传</div>
						</div>
					</a-upload>
				</a-form-model-item>
				<a-form-model-item label="排序" has-feedback prop="bannerSort">
					<a-input v-model="addForm.bannerSort" placeholder="请输入排序,小数在前" />
				</a-form-model-item>
				<a-form-model-item label="是否启用" has-feedback prop="bannerState">
					<a-radio-group name="bannerState" v-model="addForm.bannerState">
						<a-radio :value="3">是</a-radio>
						<a-radio :value="2">否</a-radio>
					</a-radio-group>
				</a-form-model-item>
			</a-form-model>
		</a-modal>
		
	</div>
</template>

<script>
	import moment from 'moment'
	export default {
		data() {
			return {
				moment,
				selectFirstMenu: window.sessionStorage.getItem('selectFirstMenu'),
				selectSecondMenu: window.sessionStorage.getItem('selectSecondMenu'),
				facilitatorList: [],
				// 搜索+表格-start
				query: {
					page: 1,
					size: 10,
					total: 0,
					facilitatorId: 1,
					bannerName: '',
				},
				mainNavigation:{},
				tableData: [],
				tableColumns: [
					{ title:'ID', dataIndex:'bannerId', key:'bannerId', align:'center'},
					{ title:'轮播图名称', key:'bannerName', align:'center', scopedSlots:{customRender:'bannerName'}},
					{ title:'所属服务商', key:'facilitatorId', align:'center', scopedSlots:{customRender:'facilitatorId'}},
					{ title:'图片', key:'bannerImg', dataIndex:'bannerImg', align:'center', scopedSlots:{customRender:'bannerImg'}},
					{ title:'排序', key:'bannerSort', dataIndex:'bannerSort',align:'center'},
					{ title:'状态', dataIndex:'bannerState', key:'bannerState', align:'center', scopedSlots:{customRender:'bannerState'}},
				],
				tableLoading: false,
				tableSelectedRows: {},
				tableSelectedRowKeys:[], // 批量选中的key
				//搜索+表格-end
				// 添加弹窗-start
				addVisible: false,
				addConfirmLoading: false,
				bannerVisibleConfig: {
					title: '添加轮播图',
					type: 'add'
				},
				addForm: {
					banner_id: '',
					bannerName: '',
					bannerImg: '',
					facilitatorId: '',
					bannerSort: '',
					columnId: '',
					bannerState: 3,
					enterpriseId:'',
				},
				addRules: {
					facilitatorId: [{ required: true, message: '请选择服务商', trigger: 'blur' }],
					bannerName: [{ required: true, message: '轮播图点名称不能为空', trigger: 'blur' }],
					bannerState: [{ required: true, message: '请选择', trigger: 'blur' }],
				},
				//图片上传-开始-----------------------------------------------------
				uploadPublic: {
					loading: false,
					taskName: 'banner',
					headers: {
						userToken: window.sessionStorage.getItem('token')
					},
				},
				//图片上传-结束
			};
		},
		methods: {
			//获取服务商列表
			async apiFacilitatorList() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiFacilitatorList,{staffId:window.sessionStorage.getItem('staffId')});
				if (res.code == 200) {
					this.facilitatorList = res.data
					this.query.facilitatorId = res.data[0].facilitatorId
					this.mainNavigation[0] = res.data[0]
					this.apiBannerQueryList()
				} else {
					this.$message.error(res.msg)
				}
			},


			//表格开始-搜索
			async apiBannerQueryList() {
				this.tableLoading = true
				for(let i=0;i<this.facilitatorList.length;i++){
					if(this.facilitatorList[i].facilitatorId == this.query.facilitatorId) {
						this.mainNavigation[0] = this.facilitatorList[i]
					}
				}
				const {
					data: res
				} = await this.$http.post(this.navigation.apiBannerQueryList, this.query);
				if (res.code == 200) {
					this.tableData = res.data.list
					this.query.page = res.data.pages.page
					this.query.size = res.data.pages.size
					this.query.total = res.data.pages.total
					// this.$message.success(res.msg)
					this.tableLoading = false
					this.tableSelectedRows = {}
					this.tableSelectedRowKeys = []
				} else {
					this.$message.error(res.msg)
					this.tableLoading = false
				}
			},
			pageChange(page, pageSize){
				this.query.page = page
				this.query.size = pageSize
				this.apiBannerQueryList()
			},
			showSizeChange(current, size){
				this.query.page = current
				this.query.size = size
				this.apiBannerQueryList()
			},
			addShow(type, item) {
				if (type == 'add') {
					this.addForm = {
						banner_id: '',
						bannerName: '',
						bannerImg: '',
						facilitatorId: '',
						bannerSort: '',
						columnId: '',
						bannerState: 3,
					},
					this.bannerVisibleConfig = {
						title: '添加轮播图',
						type: 'add'
					}
					this.addVisible = true
				}
				if (type == 'edit') {
					this.bannerVisibleConfig = {
						title: '修改轮播图',
						type: 'edit'
					}
					let items = JSON.parse(JSON.stringify(item))
					this.addForm = items
					this.addVisible = true
				}
			},
			addHandleOk() {
				this.$refs.addRuleForm.validate(valid => {
					if (valid) {
						this.addForm.staffId = window.sessionStorage.getItem('staffId')
						let httpUrl = this.navigation.apiBannerAdd
						if (this.bannerVisibleConfig.type == 'edit') {
							httpUrl = this.navigation.apiBannerEdit
						}
						this.apiBannerAdd(httpUrl)
					} else {
					  return false;
					}
				});
			},
			async apiBannerAdd(httpUrl) {
				const {
					data: res
				} = await this.$http.post(httpUrl, this.addForm);
				if (res.code == 200) {
					this.$message.success(res.msg)
					this.$refs.addRuleForm.resetFields();
					this.apiBannerQueryList()
					this.addConfirmLoading = false
					this.addVisible = false
				} else {
					this.$message.error(res.msg)
					this.addConfirmLoading = false
				}
			},
			//添加弹窗事件-结束
			
			//删除
			tableDel() {
				let that = this
				if(this.tableSelectedRows.bannerId > 0) {
					this.$confirm({
						title: '确定要删除当前选中数据吗',
						content: this.tableSelectedRows.bannerName,
						okText: '确定',
						okType: 'danger',
						cancelText: '取消',
						onOk() {
							that.apiBannerDel()
						},
						onCancel() {
						},
					});
				}else{
					this.$message.warning('请选择要删除的数据');
				}
			},
			//删除
			async apiBannerDel() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiBannerDel, {bannerId: this.tableSelectedRows.bannerId});
				if (res.code == 200) {
					this.$message.success(res.msg)
					this.apiBannerQueryList()
				} else {
					this.$message.error(res.msg)
				}
			},

			tableEdit() {
				// if(this.tableSelectedRows.bannerId > 0) {
				// 	this.edit(this.tableSelectedRows)
				// }else{
				// 	this.$message.warning('请选择要修改的数据');
				// }
			},
			
			//文件上传-开始
			beforeUpload(file) {
				const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
				// if (!isJpgOrPng) {
				// 	this.$message.error('You can only upload JPG file!');
				// }
				const isLt2M = file.size / 1024 / 1024 < 2;
				if (!isLt2M) {
					this.$message.error('请上传小于 2MB 的图片!');
				}
				return isJpgOrPng && isLt2M;
			},
			uploadHandleChange(info) {
				if (info.file.status === 'uploading') {
					this.uploadPublic.loading = true;
					return;
				}
				if (info.file.status === 'done') {
					if (this.uploadPublic.taskName == 'banner') this.addForm.bannerImg = info.file.response.data
					this.uploadPublic.loading = false;
				}
			},
			//文件上传-结束
	
			
			
		},
		computed: {
			rowSelection() {
				let that = this
				// const { selectedRowKeys } = this
				return {
					type: 'radio',
					selectedRowKeys: that.tableSelectedRowKeys,
					onChange: (selectedRowKeys, selectedRows) => {
						// console.log(selectedRows);
						that.tableSelectedRows = selectedRows[0]
						that.tableSelectedRowKeys = selectedRowKeys
					},
					// getCheckboxProps: record => ({
					// 	props: {
					// 		disabled: record.name === 'Disabled User', // Column configuration not to be checked
					// 		name: record.name,
					// 	},
					// }),
				};
			},
		},
		created() {
			this.apiFacilitatorList()
		}
	};
</script>

<style scoped>
	
</style>
